<template>
  <div class="table" align="center">
    <h6 class="mt-4 fw-bold" align="center"> 영업내역</h6>
    <table class="table-bordered" >
      <thead>
      <tr>
        <th>순번</th>
        <th v-for="(field, index) in fields" :key="index" style="position: sticky; top: 0;" >
          {{ field.title }}
        </th>
        <th>순번</th>
        <th v-for="(field, index) in fields" :key="index" style="position: sticky; top: 0;">
          {{ field.title }}
        </th>
      </tr>
      </thead>
      <tbody>

      <tr v-for="(element, index) in elements.slice(0, Math.ceil(elements.length / 2))"
          :key="index"
          @click="onSelected"
          @dblclick="onDoubleClick">

        <!-- 왼쪽 열 -->
        <td style="text-align: center">{{ index + 1 }}</td>
        <td>{{ element.minDtti }}</td>
        <td>{{ element.maxDtti }}</td>
        <td style="text-align: right">{{ element.workDist ? insertComma(element.workDist) : element.workDist }}</td>
        <td style="text-align: right">{{ element.fare ? insertComma(element.fare) : element.fare }}</td>
        <!-- 오른쪽 열 (배열 범위를 벗어나지 않도록 체크) -->
        <template v-if="index + Math.ceil(elements.length / 2) < elements.length">
          <td style="text-align: center">{{ index + Math.ceil(elements.length / 2) + 1 }}</td>
          <td>{{ elements[index + Math.ceil(elements.length / 2)].minDtti }}</td>
          <td>{{ elements[index + Math.ceil(elements.length / 2)].maxDtti }}</td>
          <td style="text-align: right">{{ elements[index + Math.ceil(elements.length / 2)].workDist ? insertComma(elements[index + Math.ceil(elements.length / 2)].workDist) : elements[index + Math.ceil(elements.length / 2)].workDist }}</td>
          <td style="text-align: right">{{ elements[index + Math.ceil(elements.length / 2)].fare ? insertComma(elements[index + Math.ceil(elements.length / 2)].fare) : elements[index + Math.ceil(elements.length / 2)].fare }}</td>
        </template>
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
import {ref} from "vue";
import tachoEntity from "@/entity/TachoEntity";
import PayType from '@/type/PayType';
import { insertComma } from "@/components/tacho/common/CommonFunc"

export default {
  name: "DrivingGraphDetailTableForPrint",
  props: {
    fields: Object,
    elements: Object,
    selectAutoScroll: Function,
    onSelected: Function,
    onDoubleClick: Function
  },
  setup(props) {
    const scroll = ref("");
    const typeList = tachoEntity.paymentTypeEnum

    const autoScroll = () => (props.selectAutoScroll !== undefined && scroll.value.scrollHeight - scroll.value.scrollTop <= scroll.value.clientHeight) ? props.selectAutoScroll() : "";

    return {
      scroll, autoScroll, typeList, insertComma
    }
  }
}
</script>

<style scoped>
table{
  width: 100%;
  align-content: center;
  justify-content: center;
  text-align: center;
}
table, th, td{
  border: 1px solid;
  border-collapse: collapse;
}
th{
  font-size: 10px;
}
td{
  font-size: 8px;
}
</style>